// extracted by mini-css-extract-plugin
module.exports = {"container":"e_CB","question":"e_DB","button":"e_EB","buttonNegative":"e_FB","buttonPositive":"e_GB","icon":"e_HB","iconNegative":"e_IB","iconPositive":"e_JB"};